<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="ql-editor" v-html="content"></div>
      </div>
      <!--<div class="wrap">-->
        <!--<img src="@/assets/images/Shop01@2x.png" alt="">-->
        <!--<div class="ql-editor">-->
          <!--<p class="ql-align-center">-->
            <!--<img src="http://www.gdmuseum.com/upload/cn/image/2022-04/1651123576652.png" height="400">-->
          <!--</p>-->
          <!--<p class="ql-align-center">	微信“扫一扫”进入广东省博物馆官方微店</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">随着2010年广东省博物馆新馆的建成开放，广东省博物馆的文创产品开发工作也进入了新的纪元。以馆徽、建筑外形、藏品与广东文化等元素为主题，广东省博物馆积极开发各类别文创产品。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">广东省博物馆始终坚持把社会效益放在首位，以服务公众为目标，近些年来不断探索并创新文创产品开发模式，依托博物馆的藏品研究、展览策划、教育活动等开发特色文创产品，将传统文化与现代生活连接，努力做到文创产品讲好藏品故事，传播岭南与文博文化。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">	积极拓展产品推广渠道，主要包括馆内外和线上销售平台，并助力打造线上、线下立体运营模式。先后在馆内开设了粤博文创商店、博物馆智慧文创商店，线上开通了广东省博物馆微店、广东省博物馆天猫旗舰店；另外，也开通广东省博物馆机场体验馆、广州塔、广州购书中心、广州新华书店四阅书店等平台，确保了产品推广效果的最大化。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">	积极推进文创产品的设计研发、销售平台的建设运营。近5年，广东省博物馆开发文创产品类别超2000款，特色文创产品先后荣获中国博物馆协会颁发的“最佳创意文创产品奖”、中国博物馆协会文创产品专业委员会颁发的“最佳制作文创产品奖”、中国文化产品交易会组委会颁发的“博物馆特色文化创意奖”、“全国百佳文化创意产品奖”以及“‘十三五’全国博物馆文创精品奖”等多项行业殊荣。广东省博物馆不断提升的文创运营质量更好地满足了公众的消费需求，也进一步提升了公共文化服务水平。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">	不断创新文创产品开发模式，开展馆校合作项目。与广州美术学院、广东轻工职业技术学院、广州工程技术职业学院等院校联合建立了“教育实践研究基地”、“文创设计教学与实践基地”、“文创产品研发基地”与战略合作，围绕博物馆特色藏品与展览等开展文创产品开发的研究与实践，设计了千余件文创作品，其中30余件优秀设计作品生产落地并在馆内销售。通过馆校合作，推动产学研深度融合，在提升博物馆文创产品开发水平、创新人才培养方式、推动区域文化的研究与传播等方面做出了积极贡献。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">	发挥粤港澳大湾区（广东）文创联盟在文创领域的交流合作与资源共享平台作用，开展文创助力乡村振兴活动。广东省博物馆作为牵头单位，在韶关市始兴县创新推出文创助力乡村振兴活动，开展乡村文创培训交流、乡村文创宣传、乡村非物质文化遗产品牌帮扶培育、乡村民俗文化体验等项目，推动文创产业协同发展。</span>-->
          <!--</p>-->
          <!--<p class="ql-align-justify">-->
            <!--<span style="font-size: 18px;">	广东省博物馆作为首批文化文物单位文化创意产品开发试点单位、中国博物馆协会文创产品专业委员会副主任委员单位、广东文创联盟理事长单位、粤港澳大湾区（广东）文创联盟理事长单位，在产品开发、开放服务、平台交流以及文化传播等方面取得了良好效益。广东省博物馆正积极调动各方面的资源和要素，守正创新，探索文创业务的更多可能，为更好地满足人民日益增长的美好生活需要做出积极贡献。</span>-->
          <!--</p>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getSingle} from "@/api";
  import {mixin} from '@/mixin/index.js';
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import Breadcrumb from "@/common/Breadcrumb";

  export default {
    name: "A1",
    mixins : [mixin],
    components: {
      Header,
      Footer,
      Banner,
      Breadcrumb
    },
    data(){
      return{
        // 富文本内容
        content: ``,
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        this.getData()
      }
    },
    created() {
      this.getData()
    },
    methods:{
      async getData(val) {
        this.content = ''
        let params = {
          pageNum: 1,
          pageSize: 10,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "文创商城",
          articleKey:'cms'
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows}} = await getSingle(params)
        rows[0].articleContent = this.updateImageUrl(rows[0].articleContent)
        this.content = rows[0].articleContent
      },
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .container{
    padding-bottom: 100px;
  }
  .wrap {
    width: 1210px;
    margin: 0 auto;
    overflow: hidden;

    >img:nth-of-type(1) {
      display: block;
      margin: 0 auto 48px;
    }

    p {
      font-family: Source Han Sans CN;
      font-size: 24px;
      color: #666666;
      line-height: 48px;

      span {
        color: #222;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Shop/A1/A1.vue